import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from "@angular/forms";
import { CommonService } from "../../_services/common.service";
import { Observable } from 'rxjs';
import { map, startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { CreateClientComponent } from '../../mnt-master/create-client/create-client.component';
import { RegisterClientComponent } from '../../mnt-master/register-client/register-client.component';
import { LoginClientComponent } from '../../mnt-master/login-client/login-client.component';
import { FlashMessagesService } from "angular2-flash-messages";
//import { CommonProjectDataService } from "../../_services/common-project-data.service";


export interface DialogData {
  user_name: string;
  paidInvoice: string,
  clientId: string
}

@Component({
  selector: 'app-save-quote',
  templateUrl: './save-quote.component.html',
  styleUrls: ['./save-quote.component.css']
})
export class SaveQuoteComponent implements OnInit {
  userList: Array<any> = [];
  searchTextboxControl = new FormControl();
  filteredOptions: Observable<any[]>;
  public isShowError = false;
  public isValueSet = false;
  public isPublicQuoteCreation = false;
  public isClientUserDetails: any = false;
  public clientId: string = '';
  
  constructor(
    public dialogRef: MatDialogRef<SaveQuoteComponent>,
    private dialog: MatDialog,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private activateroute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: DialogData

  ) {
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;
    if (this.isClientUserDetails && this.isPublicQuoteCreation == true) {
      this.dialogRef.close(this.isClientUserDetails);
    }
    
    const startWithText = this.data.user_name ? this.data.user_name : '';
    this.filteredOptions = this.searchTextboxControl.valueChanges.pipe(
      startWith(startWithText),
      debounceTime(600),
      distinctUntilChanged(),
      switchMap(searchText => this.getClientList(searchText).pipe(
        map(results => this._filter(results, searchText))
      ))
    ); 
  }

  ngOnInit() {
    this.clientId = this.data.clientId ? this.data.clientId : '';
  }

  onKey(event: any) { // without type info
    // console.log(event.target.value)
    // this.getClientList(event.target.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private _filter(results: any, searchText: string): Array<any> {
    const filterValue = searchText.toLowerCase();
    return results.filter(option => {
      const firstName = option.first_name ? option.first_name.toLowerCase() : '';
      const lastName = option.last_name ? option.last_name.toLowerCase() : '';
      const fullName = (firstName + ' ' + lastName).trim();
      const companyName = option.company_name ? option.company_name.toLowerCase() : '';
      const email = option.email ? option.email.toLowerCase() : '';
  
      return firstName.includes(filterValue) || 
        lastName.includes(filterValue) || 
        fullName.includes(filterValue) ||
        companyName.includes(filterValue) ||
        email.includes(filterValue);
    });
  }  

  clearSearch(event) {
    event.stopPropagation();
    this.searchTextboxControl.patchValue('');
  }

  openAddClientDialog(): void {
    const dialogRef = this.dialog.open(CreateClientComponent, {
      width: "900px",
      //maxWidth: "auto",
      disableClose: true,
      data: {
        saveFrom: 'Order'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != "success") {
        this.searchTextboxControl.patchValue(result);
        this.getClientList(result);
      }
    });
  }

  saveQuote(client) {
    this.isShowError = false;
    if (client == 'Guest') {
      this.dialogRef.close(client);
      localStorage.setItem("CLIEINT_TYPE", "Guest");
    }
    else {
      localStorage.removeItem("CLIEINT_TYPE");
      let clientData = this.userList.find(x => x.user_id === this.clientId);
      if (clientData) {
        this.dialogRef.close(clientData);
      }
      else {
        this.isShowError = true;
        this._flashMessagesService.show("please select valid user", {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    }

  }

  getClientList = function (searchText = ""): Observable<any[]> {
    return new Observable(observer => {
      if (searchText.length >= 3) {
        this.loading = true;
        this.customeItemOptions = {
          id: localStorage.getItem("userID"),
          search: searchText
        };
        this.CommonService.apiService(
          "POST",
          "users/list",
          this.customeItemOptions
        ).subscribe(
          (response: any) => {
            this.loading = false;
            if (response.status === true && response.data) {
              this.userList = response.data.records;
              if (this.isValueSet === false && this.data.user_name != '') {
                this.searchTextboxControl.patchValue(this.data.user_name);
                this.isValueSet = true;
              }
              this.isValueSet = true;
              observer.next(this.userList);
              observer.complete();
            } else {
              observer.next([]);
              observer.complete();
            }
          },
          err => {
            this.loading = false;
            console.log(err);
            observer.error(err);
          }
        );
      } else {
        observer.next([]);
        observer.complete();
      }
    });
  }

  openRegisterClientDialog(): void {
    const dialogRef = this.dialog.open(RegisterClientComponent, {
      width: "900px",
      //maxWidth: "auto",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != "success") {
        if (this.isPublicQuoteCreation == true) {
          let currentUrl = this.router.url;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
        this.dialogRef.close(result);
      }
    });
  }

  openLoginClientDialog(): void {
    const dialogRef = this.dialog.open(LoginClientComponent, {
      width: "900px",
      //maxWidth: "auto",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != "success") {
        if (this.isPublicQuoteCreation == true) {
          let currentUrl = this.router.url;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
        this.dialogRef.close(result);
      }
    });
  }

  saveQuoteByIsClient(client) {
    if (this.isClientUserDetails) {
      this.dialogRef.close(client);
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  onOptionSelected(event: any) {
    const selectedOption = event.option.value;
    this.clientId = selectedOption.user_id;
    this.searchTextboxControl.setValue(selectedOption.name);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/save-quote/save-quote.component.ts